export class Country {
  dialCode;
  id;
  isoCode;
  name;
  object_Type;

  constructor(obj?: Country) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/vocabularies/countries/countries.model.ts